<template>
  <header class="header-area header-sticky">
    <div class="container">
      <div class="header">
        <div class="header-inner container">
          <div class="row">
            <div class="col-lg-6 col-12">
              <a
                class="navbar-brand"
                href="/"
                title="Home"
                style="display: none"
                ><h1 class="hidden">
                  <img
                    src="../assets/images/esg-logo-small.png"
                    alt="The Edge ESG Awards 2022"
                  />
                  The Edge ESG Awards 2022
                </h1>
              </a>
            </div>
            <div class="col-lg-6 col-12">
              <div class="row sponsors text-center">
                <div class="col-3">
                  <span class="text-uppercase">Main Partner <br /> </span>
                  <img
                    class="img-fluid mx-auto"
                    src="../assets/images/sponsored/uob.png?=v2"
                  />
                </div>
                <div class="col-3">
                  <span class="text-uppercase text-center"
                    >Knowledge Partner <br />
                    (Funds Category)</span
                  >
                  <img
                    class="img-fluid mx-auto"
                    src="../assets/images/sponsored/morningstar.png?=v1"
                  />
                </div>
                <div class="col-3">
                  <span class="text-uppercase text-center"
                    >Auditor <br />
                  </span>
                  <img
                    class="img-fluid mx-auto"
                    src="../assets/images/sponsored/deloitte.png?=v1"
                  />
                </div>
                <div class="col-3">
                  <span class="text-uppercase text-center"
                    >Official <br />
                    Broadcast <br />
                    Partner</span
                  >
                  <img
                    class="img-fluid mx-auto"
                    src="../assets/images/sponsored/astro-awani.png?=v2"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <nav class="main-nav">
            <!-- ***** Logo Start ***** -->
            <a href="/" class="logo">
              <img src="../assets/images/esg-logo-small.png" alt="" />
            </a>
            <!-- ***** Logo End ***** -->
            <!-- ***** Menu Start ***** -->
            <!-- <scrollactive ref="scrollactive"> -->
            <ul class="nav">
              <li class="scroll-to-section scrollactive-item">
                <!-- <router-link to="/" class="menu-item">Home</router-link> -->
                <!-- <a href="#welcome" class="menu-item">Home</a> -->
                <router-link
                  :to="{ name: 'home', hash: '#welcome' }"
                  class="menu-item"
                  >Home</router-link
                >
              </li>
              <li class="scroll-to-section scrollactive-item">
                <!-- <a href="#about" class="menu-item">About</a> -->
                <router-link
                  :to="{ name: 'home', hash: '#about' }"
                  class="menu-item"
                  >About</router-link
                >
              </li>
              <li class="scroll-to-section scrollactive-item">
                <!-- <a href="#methodology" class="menu-item">Methodology</a> -->
                <router-link
                  :to="{ name: 'home', hash: '#methodology' }"
                  class="menu-item"
                  >Methodology</router-link
                >
              </li>
              <li class="submenu">
                <a href="javascript:;" @click="showMore()">More</a>
                <ul>
                  <li>
                    <!-- <a href="" class="menu-item">Articles</a> -->
                    <router-link to="/article" class="menu-item"
                      >Articles</router-link
                    >
                  </li>
                  <li>
                    <router-link to="/fullreport" class="menu-item"
                      >Full Report</router-link
                    >
                  </li>
                  <li>
                    <!-- <a href="gallery.html" target="_blank" class="menu-item"
                      >Gallery</a
                    > -->
                    <router-link to="/gallery" class="menu-item"
                      >Gallery</router-link
                    >
                  </li>
                  <li>
                    <router-link to="/winner" class="menu-item"
                      >Winner List</router-link
                    >
                  </li>
                </ul>
              </li>
              <!-- <li class="scroll-to-section"><a href="#contact-us" class="menu-item">Contact Us</a></li> -->
            </ul>
            <!-- </scrollactive> -->
            <a class="menu-trigger" @click="menuShow()">
              <span>Menu</span>
            </a>
            <!-- ***** Menu End ***** -->
          </nav>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  methods: {
    menuShow() {
      var menumobil = document.querySelector(".menu-trigger");
      menumobil.classList.toggle("active");
      document.querySelector(".menu-trigger").classList.contains("active")
        ? document.querySelector(".main-nav .nav").classList.add("show")
        : document.querySelector(".main-nav .nav").classList.remove("show");
    },
    showMore() {
      document
        .querySelector(".main-nav .nav li.submenu ul")
        .classList.toggle("active");
    },
  },
};
</script>

<style></style>
